import {UPDATE_FIRSTNAME} from '../reducers/usrfields.js';
import {UPDATE_LASTNAME} from '../reducers/usrfields.js';
import {UPDATE_EMAIL} from '../reducers/usrfields.js';
import {UPDATE_ISMEMBER} from '../reducers/usrfields.js';
import {UPDATE_BRANCH} from '../reducers/usrfields.js';
import {UPDATE_PHONE} from '../reducers/usrfields.js';
import {UPDATE_MISC} from '../reducers/usrfields.js';

export default function updateinputfield(value, field, validatenumber = true){

    const fvalue = value;
    switch(field){
        case "firstname":
            return{
                'type': UPDATE_FIRSTNAME,
                'value': fvalue
            }
        case "lastname":
            return{
                'type': UPDATE_LASTNAME,
                'value': fvalue
            }
        case "email":
            return{
                'type': UPDATE_EMAIL,
                'value': fvalue
            }
        case "member":
            return{
                'type': UPDATE_ISMEMBER,
                'value': fvalue
            }
        case "branch":
            return{
                'type': UPDATE_BRANCH,
                'value': fvalue
            }
        case "phone":
            return{
                'type': UPDATE_PHONE,
                'value': fvalue
            }
        default:
            return {
                'type': UPDATE_MISC,
                'value': fvalue,
                'title': field
            }
    }
}

